import { Component, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, NavigationStart } from '@angular/router';
import { AuthService } from './auth.service';
import { LoginService } from './login.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styles: ["./app.component.css"]
})
export class AppComponent implements AfterViewInit {
  title = 'Kanban';
  exibirMenu:boolean = false;
  logado:boolean = false;
  
  constructor(public  route: ActivatedRoute,
              public  router: Router,
              private login: LoginService,
              private auth: AuthService) {}

  ngAfterViewInit() {
    eval("window.M.Sidenav.init(document.querySelectorAll('.sidenav'), {})");

    this.router.events.subscribe(event => {
      /*
      if (event instanceof NavigationStart) {
        if (this.router.routerState.snapshot.url !== '/' && this.router.routerState.snapshot.url !== '/login') {
          this.exibirMenu = false;
          this.auth.logout();
        }
      }
      */

      if (event instanceof NavigationEnd) {
        //console.log('status: ', this.auth.isLoggedIn());
        this.logado = this.auth.isLoggedIn();
      }
    });
  }

  cadastrarProjeto() {
    this.router.navigate(["/cadastro-projeto"]);
  }

  listarProjetos() {
    this.router.navigate(["/projetos"]);
  }

  logout() {
    this.login.setUsuario('');
    this.logado = this.auth.isLoggedIn();
    this.router.navigate(["/login"]);
  }
}